<template>
  <div>
    <banner img-path="woundcare.jpg" banner-text="Woundcare Products"/>
    <catalogue-section v-for="(catalogue, company, index) in catalogues" :key="index" :catalogue-sections="catalogue" :catalogue-heading="company" :catalogue-index="index"/>
  </div>
</template>

<script>
import CatalogueSection from '../components/CatalogueSection.vue'
import banner from '@/components/Banner.vue'

export default {
  components: { CatalogueSection, banner},
  // eslint-disable-next-line
    name: 'Woundcare',
    data(){
        return{
            catalogues : require("../assets/wound-care.json"),
        }
    },
}
</script>